import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Shield, Trophy, TrendingUp, Info } from 'lucide-react';
import { useAdmin } from '../contexts/AdminContext';

const Navbar = () => {
  const location = useLocation();
  const { isAuthenticated, logout } = useAdmin();

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bg-gray-850/95 backdrop-blur-sm border-b border-gray-700/50 sticky top-0 z-50">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group">
            <div className="p-2 bg-gradient-to-br from-primary-500 to-primary-600 rounded-lg group-hover:shadow-lg transition-all duration-200">
              <Trophy className="h-6 w-6 text-white" />
            </div>
            <div>
              <h1 className="text-xl font-bold gradient-text">CS2 Skins</h1>
              <p className="text-xs text-gray-400 -mt-1">Ranking</p>
            </div>
          </Link>

          {/* Navigation Links */}
          <div className="hidden md:flex items-center space-x-1">
            <Link
              to="/"
              className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-all duration-200 font-medium ${
                isActive('/') 
                  ? 'bg-primary-600/20 text-primary-300 border border-primary-600/30' 
                  : 'text-gray-300 hover:text-white hover:bg-gray-700/50'
              }`}
            >
              <TrendingUp className="h-4 w-4" />
              <span>Rankings</span>
            </Link>

            <Link
              to="/ranking-system"
              className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-all duration-200 font-medium ${
                isActive('/ranking-system') 
                  ? 'bg-primary-600/20 text-primary-300 border border-primary-600/30' 
                  : 'text-gray-300 hover:text-white hover:bg-gray-700/50'
              }`}
            >
              <Info className="h-4 w-4" />
              <span>How It Works</span>
            </Link>

            {isAuthenticated ? (
              <div className="flex items-center space-x-1 ml-4">
                <Link
                  to="/admin"
                  className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-all duration-200 font-medium ${
                    isActive('/admin') 
                      ? 'bg-green-600/20 text-green-300 border border-green-600/30' 
                      : 'text-gray-300 hover:text-white hover:bg-gray-700/50'
                  }`}
                >
                  <Shield className="h-4 w-4" />
                  <span>Admin</span>
                </Link>
                <button
                  onClick={logout}
                  className="text-gray-300 hover:text-white hover:bg-gray-700/50 px-4 py-2 rounded-lg transition-all duration-200 font-medium"
                >
                  Logout
                </button>
              </div>
            ) : (
              <div></div>
            )}
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button className="text-gray-300 hover:text-white p-2">
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;